var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198 87",
    width: 198,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vector-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-56h198v143h-198z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #cccccc } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #3f3d56 } \n\t\t.s3 { fill: #f2f2f2 } \n\t\t.s4 { fill: #252f6a } \n\t\t.s5 { fill: #ffb8b8 } \n\t\t.s6 { fill: #2f2e41 } \n\t\t.s7 { fill: #e6e6e6 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m197.7 85.9h-197.4q-0.1 0-0.2-0.1-0.1-0.1-0.1-0.2 0-0.1 0.1-0.2 0.1-0.1 0.2-0.1h197.4q0.1 0 0.2 0.1 0.1 0.1 0.1 0.2 0 0.1-0.1 0.2-0.1 0.1-0.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m178.2 36h-116.2c-0.5 0-1 0.2-1.3 0.6-0.4 0.3-0.6 0.8-0.6 1.3 0 0.5 0.2 0.9 0.6 1.3 0.3 0.3 0.8 0.5 1.3 0.5h3.3v44.5c0 0.5 0.2 1 0.5 1.3 0.4 0.4 0.9 0.6 1.4 0.6 0.4 0 0.9-0.2 1.3-0.6 0.3-0.3 0.5-0.8 0.5-1.3v-44.5h101.9v44.5c0 0.5 0.2 1 0.5 1.3 0.4 0.4 0.8 0.6 1.3 0.6 0.5 0 1-0.2 1.4-0.6 0.3-0.3 0.5-0.8 0.5-1.3v-43.5l0.5-1h3.1c0.5 0 0.9-0.2 1.3-0.5 0.3-0.4 0.5-0.8 0.5-1.3 0-0.5-0.2-1-0.5-1.3-0.4-0.4-0.8-0.6-1.3-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m126.4 37h-35.2c-0.7 0-1.3-0.3-1.8-0.8-0.5-0.4-0.7-1.1-0.7-1.8v-19.4c0-0.6 0.2-1.3 0.7-1.8 0.5-0.5 1.1-0.7 1.8-0.7h35.2c0.7 0 1.3 0.2 1.8 0.7 0.5 0.5 0.8 1.2 0.8 1.8v19.4c0 0.7-0.3 1.4-0.8 1.8-0.5 0.5-1.1 0.8-1.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m126.4 14.5h-35.2q-0.2 0-0.4 0.1-0.2 0.2-0.2 0.4v19.4q0 0.3 0.2 0.4 0.2 0.2 0.4 0.2h35.2q0.3 0 0.4-0.2 0.2-0.1 0.2-0.4v-19.4q0-0.2-0.2-0.4-0.1-0.1-0.4-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m129.4 34.6h-3.8q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.2q-0.1 0-0.2 0.1-0.2 0.2-0.2 0.3h-1.1q0-0.1-0.2-0.3-0.1-0.1-0.2-0.1h-1.2q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.2q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.2q-0.1 0-0.2 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.2-0.1-0.3-0.1h-1.2q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.2q-0.1 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.1q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.2-0.1-0.3-0.1h-1.2q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.2q-0.1 0-0.2 0.1-0.2 0.2-0.2 0.3h-1.1q-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.1h-1.2q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-1.2q0-0.1-0.1-0.3-0.1-0.1-0.3-0.1h-1.2q-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3h-3.7c-0.4 0-0.7 0.1-0.9 0.4-0.2 0.2-0.3 0.5-0.3 0.8 0 0.3 0.1 0.6 0.3 0.8 0.2 0.3 0.5 0.4 0.9 0.4h41.1c0.3 0 0.6-0.1 0.8-0.4 0.2-0.2 0.4-0.5 0.4-0.8 0-0.3-0.2-0.6-0.4-0.8-0.2-0.3-0.5-0.4-0.8-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m82.1 27.7v7.9h-19.7q-0.8 0-1.5-0.3-0.8-0.2-1.4-0.8-0.5-0.6-0.9-1.3-0.3-0.7-0.3-1.5 0-0.8 0.3-1.6 0.4-0.7 0.9-1.3 0.6-0.5 1.4-0.8 0.7-0.3 1.5-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m82.6 35.5q0 0.2-0.1 0.3-0.1 0-0.2 0h-20.2c-1.1 0-2.2-0.4-3-1.2-0.8-0.8-1.2-1.8-1.2-2.9 0-1.1 0.4-2.2 1.2-2.9 0.8-0.8 1.9-1.3 3-1.3h20.2q0.1 0 0.2 0.1 0.1 0.1 0.1 0.2 0 0.2-0.1 0.3-0.1 0-0.2 0.1h-20.2c-1 0-1.9 0.3-2.5 1-0.7 0.7-1.1 1.6-1.1 2.5 0 0.9 0.4 1.8 1.1 2.5 0.6 0.7 1.5 1 2.5 1h20.2q0.1 0 0.2 0.1 0.1 0.1 0.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m82.1 29.5h-21.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0h21.2q0.1 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m82.1 31h-21.2q0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h21.2q0.1 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m82.1 32.5h-21.2q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0h21.2q0.1 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0.1-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m82.1 33.9h-21.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h21.2q0.1 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m78.4 19.4v7.9h-19.7q-0.8 0-1.6-0.3-0.7-0.2-1.3-0.8-0.6-0.6-0.9-1.3-0.3-0.7-0.3-1.5 0-0.8 0.3-1.6 0.3-0.7 0.9-1.3 0.6-0.5 1.3-0.8 0.8-0.3 1.6-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m78.9 27.2q0 0.2-0.1 0.3-0.1 0-0.2 0h-20.3q-0.8 0-1.5-0.3-0.8-0.3-1.4-0.9-0.6-0.6-0.9-1.3-0.3-0.8-0.3-1.6 0-0.8 0.3-1.6 0.3-0.8 0.9-1.3 0.6-0.6 1.4-0.9 0.7-0.3 1.5-0.4h20.3q0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.3 0 0.1-0.1 0.2-0.1 0.1-0.2 0.1h-20.3c-0.9 0-1.8 0.3-2.5 1-0.6 0.7-1 1.6-1 2.5 0 0.9 0.4 1.8 1 2.5 0.7 0.7 1.6 1 2.5 1h20.3q0.1 0 0.2 0.1 0.1 0.1 0.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m78.4 21.2h-21.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0h21.2q0 0 0.1 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m78.4 22.7h-21.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h21.2q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m78.4 24.2h-21.2q0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0h21.2q0 0 0.1 0.1 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m78.4 25.6h-21.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h21.2q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m101.4 63.6v-6.9c0-0.3-0.1-0.6-0.4-0.8-0.2-0.2-0.5-0.3-0.8-0.3h-26c-0.3 0-0.6 0.1-0.8 0.3-0.2 0.2-0.4 0.5-0.4 0.8v6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m101.4 66.2h-28.4v8.8h28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m73 77.6v6.9c0 0.3 0.2 0.6 0.4 0.8 0.2 0.2 0.5 0.3 0.8 0.3h26c0.3 0 0.6-0.1 0.8-0.3 0.3-0.2 0.4-0.5 0.4-0.8v-6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m87.1 60.7c0.4 0 0.8-0.4 0.8-0.8 0-0.5-0.4-0.9-0.8-0.9-0.5 0-0.9 0.4-0.9 0.9 0 0.4 0.4 0.8 0.9 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m87.1 72.2c0.4 0 0.8-0.4 0.8-0.9 0-0.5-0.4-0.8-0.8-0.8-0.5 0-0.9 0.3-0.9 0.8 0 0.5 0.4 0.9 0.9 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m87.1 83.4c0.5 0 0.9-0.4 0.9-0.9 0-0.5-0.4-0.8-0.9-0.8-0.5 0-0.8 0.3-0.8 0.8 0 0.5 0.3 0.9 0.8 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m98.2 47.8v7.8h-19.8q-0.8 0.1-1.5-0.2-0.8-0.3-1.3-0.9-0.6-0.5-0.9-1.3-0.3-0.7-0.3-1.5 0-0.8 0.3-1.6 0.3-0.7 0.9-1.2 0.5-0.6 1.3-0.9 0.7-0.3 1.5-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m98.6 55.6q0 0.1 0 0.2-0.1 0.1-0.3 0.1h-20.2q-0.8 0-1.6-0.3-0.8-0.4-1.4-0.9-0.5-0.6-0.9-1.4-0.3-0.8-0.3-1.6 0-0.8 0.3-1.6 0.4-0.7 0.9-1.3 0.6-0.6 1.4-0.9 0.8-0.3 1.6-0.3h20.2q0.2 0 0.3 0.1 0 0 0 0.2 0 0.1 0 0.2-0.1 0.1-0.3 0.1h-20.2c-1 0-1.9 0.3-2.5 1-0.7 0.7-1.1 1.6-1.1 2.5 0 1 0.4 1.9 1.1 2.5 0.6 0.7 1.5 1.1 2.5 1.1h20.2q0.2 0 0.3 0.1 0 0 0 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.2 49.6h-21.2q-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0.1-0.1h21.2q0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.2 51h-21.2q-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0.1 0h21.2q0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.2 52.5h-21.2q-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0h21.2q0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.2 53.9h-21.2q-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0.1 0h21.2q0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m144.7 33.6h-9q-0.2 0-0.3 0l-2.2 1.1q-0.2 0.1-0.2 0.2-0.1 0.1-0.1 0.2 0 0.1 0.1 0.3 0 0.1 0.2 0.1l2.2 1.1q0.1 0.1 0.3 0.1h9q0.1 0 0.3-0.1 0.1-0.1 0.2-0.3v-2.3q-0.1-0.2-0.2-0.3-0.2-0.2-0.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m145.2 34v2.3q-0.1 0.2-0.2 0.3-0.2 0.1-0.3 0.1h-1.8v-3.1h1.8q0.1-0.1 0.3 0.1 0.1 0.1 0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m144.6 16.6q0.6-0.3 1.3-0.3 0.7 0 1.3 0.3 0.6 0.3 1 0.8 0.5 0.5 0.6 1.1 0.1 0.2 0.1 0.4l12.6 6.3 2.9-1.9 3.6 4.1-4.4 3.6c-0.5 0.5-1.2 0.7-1.9 0.7-0.7 0.1-1.3-0.1-1.9-0.5l-12.8-8.8q-0.1 0-0.3 0.1-0.6 0.2-1.3 0.1-0.6-0.1-1.2-0.5-0.6-0.3-1-0.9-0.3-0.5-0.5-1.2 0-0.2 0-0.4c0-0.6 0.1-1.3 0.5-1.8 0.3-0.6 0.8-1 1.4-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m170.8 54.9h-13.8c0 0.4-14.1 0.8-14.1 0.8q-0.4 0.2-0.6 0.5c-0.6 0.7-0.9 1.5-0.9 2.3v0.6c0 0.9 0.4 1.8 1.1 2.5 0.7 0.7 1.6 1.1 2.5 1.1h25.8c0.9 0 1.8-0.4 2.5-1.1 0.7-0.7 1-1.6 1-2.5v-0.6c0-0.9-0.3-1.8-1-2.5-0.7-0.7-1.6-1.1-2.5-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m155.8 86.5h3.8v-24h-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m145.2 86.4c0 0.4 5.7 0.2 12.6 0.2 7 0 12.6 0.2 12.6-0.2 0-0.4-5.6-3.6-12.6-3.6-6.9 0-12.6 3.2-12.6 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m148.6 83.6h-3.5l-1.7-9.1h5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m149.5 87h-11.3v-0.1q0-0.9 0.3-1.7 0.4-0.8 1-1.5 0.6-0.6 1.4-0.9 0.8-0.3 1.7-0.3h6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m143.4 78l-7-15.7c-0.6-1.3-0.7-2.8-0.2-4.2 0.4-1.4 1.4-2.5 2.7-3.2l15.2-8.1 6.9-0.6 6.4-0.6v0.1c0.1 0.1 1.4 2.5 0.5 5.1-0.7 1.9-2.5 3.5-5.4 4.5-6.8 2.5-14.7 4.6-17.7 5.4q-0.2 0.1-0.4 0.2-0.1 0.2-0.2 0.3-0.1 0.2-0.2 0.4 0 0.2 0.1 0.4l6.5 14.6q0.1 0.3 0.1 0.6-0.1 0.3-0.2 0.6-0.2 0.2-0.4 0.4-0.3 0.1-0.6 0.2l-4.8 0.3q-0.1 0-0.2 0-0.4 0-0.7-0.2-0.3-0.2-0.4-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m150.3 83.6h-3.5l-1.7-9.1h5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m151.2 87h-11.3v-0.1q0-0.9 0.3-1.7 0.4-0.8 1-1.5 0.6-0.6 1.4-0.9 0.8-0.3 1.7-0.3h6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m145.4 78.8l-7-15.7c-0.6-1.3-0.7-2.8-0.2-4.1 0.5-1.4 1.4-2.5 2.7-3.2l15.2-8.2 6.9-0.6 6.4-0.5c0.1 0.1 1.4 2.5 0.5 5.1-0.7 2-2.5 3.5-5.4 4.6-6.8 2.5-14.7 4.6-17.7 5.4q-0.2 0.1-0.4 0.2-0.1 0.1-0.2 0.3-0.1 0.2-0.2 0.4 0 0.2 0.1 0.4l6.5 14.6q0.1 0.3 0.1 0.6-0.1 0.3-0.2 0.5-0.2 0.3-0.4 0.4-0.3 0.2-0.6 0.2l-4.8 0.4q-0.1 0-0.2 0-0.3 0-0.7-0.2-0.3-0.2-0.4-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m141.9 30.9c-3-3.9-5.3-8.2-6.9-12.8q-0.2-0.5 0-0.9 0.2-0.4 0.6-0.6l10-5.4q0.3-0.1 0.5-0.1 0.3-0.1 0.6 0.1 0.2 0.1 0.4 0.3 0.2 0.2 0.3 0.5c1.2 4.4 3.4 8.5 6.4 12q0.2 0.2 0.3 0.5 0.1 0.2 0 0.5 0 0.3-0.2 0.5-0.2 0.2-0.4 0.4l-10.1 5.4q-0.4 0.2-0.8 0.1-0.5-0.1-0.7-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m142.6 30.4q0 0.1 0.2 0.1 0.1 0.1 0.2 0l10.1-5.4q0.1 0 0.1-0.1 0.1-0.1 0.1-0.1 0-0.1 0-0.2-0.1-0.1-0.1-0.2c-3.2-3.5-5.4-7.7-6.6-12.3q-0.1-0.1-0.1-0.2-0.1 0-0.2-0.1 0 0-0.1 0-0.1 0-0.2 0.1l-10 5.3q-0.1 0.1-0.2 0.2 0 0.2 0 0.3c1.6 4.5 3.9 8.8 6.8 12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m175.3 29.5l-7.9 3-1.9-5.4c-0.3-0.7-0.3-1.4 0-2.2 0.3-0.7 0.8-1.3 1.4-1.6 0.7-0.4 1.5-0.5 2.2-0.4 0.7 0.2 1.4 0.6 1.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m155.2 50.6q-0.2-0.1-0.4-0.4-0.1-0.3-0.1-0.6c-1.1-9.4-0.4-16.8 2.1-22.5 0.4-1 1.1-1.9 1.9-2.6 0.8-0.7 1.8-1.2 2.8-1.5l6.4-0.3c1.5 0.7 2.6 1.9 3.4 3.3 0.7 1.4 1 3.1 0.7 4.6-2 5.4-3.8 11-2.4 15.6q0 0.3 0 0.6 0 0.3-0.2 0.5-0.1 0.3-0.4 0.4-0.2 0.2-0.5 0.3l-12.1 2.9q-0.3 0-0.6 0-0.3-0.1-0.6-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m165.8 20.3c3.9 0 7-3.1 7-7 0-3.9-3.1-7-7-7-3.9 0-7 3.1-7 7 0 3.9 3.1 7 7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m146.3 18.9l-5.5 2.4q-0.3 0.1-0.7 0-0.3-0.1-0.4-0.4l-0.2-0.3q-0.1-0.4 0-0.7 0.2-0.3 0.5-0.5l5.5-2.4q0.3-0.1 0.6 0 0.3 0.1 0.5 0.4l0.1 0.4q0.2 0.3 0 0.6-0.1 0.3-0.4 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m148.3 22.6l-5.5 2.4q-0.3 0.2-0.7 0-0.3-0.1-0.4-0.4l-0.2-0.3q-0.1-0.3 0-0.7 0.2-0.3 0.5-0.5l5.5-2.4q0.3-0.1 0.6 0 0.3 0.1 0.5 0.5l0.1 0.3q0.2 0.3 0 0.6-0.1 0.4-0.4 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m152.5 37.1l-12.2-9.6q-0.1 0.1-0.3 0.1-0.7 0.1-1.3 0-0.7-0.1-1.2-0.5-0.6-0.4-0.9-1-0.4-0.5-0.4-1.2c-0.1-0.7 0-1.4 0.4-2 0.4-0.6 0.9-1.1 1.6-1.3q0.6-0.3 1.3-0.2 0.7 0 1.3 0.4 0.6 0.3 1 0.8 0.4 0.6 0.5 1.2 0.1 0.2 0.1 0.4l12.2 7 3-1.7 3.3 4.4-4.7 3.3c-0.5 0.4-1.2 0.6-1.8 0.6-0.7 0-1.4-0.3-1.9-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m162.4 35.2l-6.9-4.7 3.2-4.6c0.5-0.6 1.1-1.1 1.8-1.3 0.8-0.2 1.5-0.1 2.2 0.2 0.7 0.4 1.3 0.9 1.6 1.6 0.3 0.7 0.3 1.5 0.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m163.2 12.3c-1.8 1.2-4.2 2.5-6 1.2-1.2-0.9-1.6-2.5-1.1-3.9 0.9-2.5 3.3-3.6 5.6-4.5 3-1.1 6.3-2 9.4-1.2 3.1 0.8 5.9 3.8 5.3 7-0.4 2.5-2.8 4.6-2.5 7.2 0.4 2.6 3.3 3.9 5.8 4.4 2.6 0.5 5.4 0.6 7.3 2.4 2.3 2.4 1.8 6.6-0.5 9.1-2.2 2.4-5.5 3.6-8.7 4.3-4.3 1-8.9 1.6-13-0.1-4.1-1.7-7.2-6.2-6-10.4 0.4-1.8 1.6-3.3 2.8-4.8 1.1-1.5 2.2-3 2.7-4.8 0.3-1.5 0.1-3.3-0.9-4.4q-0.3-0.3-0.4-0.7 0-0.4 0.2-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m31.2 46.4c-1.8 0.6-3.7 0.8-5.6 0.5-1.9-0.4-3.7-1.2-5.2-2.4-3.8-3.2-5-8.4-5.9-13.2q-1.4-7.2-2.9-14.3l6 4.1c4.3 2.9 8.7 6 11.7 10.3 2.9 4.2 4.2 10.1 1.8 14.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m30.7 63.7c0.6-4.4 1.2-8.8 0.8-13.3-0.4-3.9-1.6-7.8-4-10.9-1.3-1.7-2.9-3.2-4.7-4.3-0.5-0.3-0.9 0.5-0.5 0.8 3.2 1.9 5.6 4.8 6.9 8.2 1.5 3.8 1.7 8 1.5 12-0.2 2.5-0.5 4.9-0.8 7.3q-0.1 0.2 0 0.3 0.1 0.2 0.3 0.2 0.1 0.1 0.3 0 0.1-0.1 0.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m24.9 56c-0.8 1.1-1.9 2.1-3.1 2.7-1.3 0.7-2.7 1-4.1 1-3.6-0.2-6.6-2.8-9.4-5.2l-8-7.1 5.3-0.2c3.8-0.2 7.8-0.4 11.4 0.8 3.7 1.2 7 4 7.7 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m32.4 66.3c-2.9-5.2-6.3-10.9-12.3-12.7-1.7-0.5-3.4-0.7-5.2-0.6-0.5 0.1-0.4 0.9 0.2 0.9 2.9-0.3 5.8 0.5 8.2 2.2 2.3 1.6 4.2 3.8 5.7 6.1 0.9 1.4 1.8 2.9 2.6 4.4 0.3 0.5 1.1 0.2 0.8-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m37.1 71.7c-0.1-1.1-0.5-2.2-1.2-3.2-0.7-0.9-1.6-1.6-2.7-2v-3h-4.9v3.1c-1 0.4-1.9 1.1-2.5 2-0.7 0.9-1.1 2-1.2 3.1l-1.1 13.6h14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m110.7 27l-0.9-0.5c0.4 0.6 0.7 1.4 0.9 2 0.3-0.6 0.8-1.3 1.2-1.8l-0.9 0.3c0.6-2.9 2.8-5 5.3-5l0.1-0.1c-2.7 0-5.1 2.1-5.7 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m114.9 31.4h-5.7c-0.3 0-0.5-0.2-0.5-0.4 0-0.3 0.2-0.5 0.5-0.5h5.7c0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.4-0.5 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m122.6 31.4h-5.8c-0.2 0-0.4-0.2-0.4-0.4 0-0.3 0.2-0.5 0.4-0.5h5.8c0.2 0 0.4 0.2 0.4 0.5 0 0.2-0.2 0.4-0.4 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m119.2 19.4h-5.6c-0.2 0-0.3-0.1-0.3-0.3 0-0.1 0.1-0.2 0.3-0.2h5.6c0.1 0 0.2 0.1 0.2 0.2 0 0.2-0.1 0.3-0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m122.2 22.1h-11.6c-0.1 0-0.3-0.1-0.3-0.3 0-0.1 0.2-0.2 0.3-0.2h11.6c0.1 0 0.2 0.1 0.2 0.2 0 0.2-0.1 0.3-0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m100.5 29.9q0 0 0 0c-1.1-0.1-4.5-0.8-6.5-4.5-0.1-0.3-0.1-0.7 0.2-0.9l4.1-4.5c0.1-0.1 0.4-0.2 0.6-0.2 0.2 0 0.6 0.1 0.7 0.4 0.4 1.8 2.2 4.1 4.6 4.5 0.2 0.1 0.4 0.3 0.5 0.6 0 0.3-0.1 0.5-0.2 0.7l-3.3 3.7c-0.2 0.1-0.4 0.2-0.7 0.2zm-1.6-9.9c-0.2 0-0.4 0-0.5 0.2l-4.1 4.4c-0.2 0.2-0.2 0.5-0.1 0.7 1.9 3.7 5.3 4.3 6.3 4.4 0.2 0.1 0.4 0 0.5-0.2l3.3-3.6q0.2-0.2 0.2-0.5c-0.1-0.2-0.2-0.5-0.4-0.5-2.4-0.4-4.3-2.8-4.7-4.7 0-0.1-0.3-0.2-0.5-0.2q0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m96.4 25.7l2.9-2.7c0.2-0.2-0.1-0.5-0.3-0.3l-2.9 2.7c-0.2 0.1 0.1 0.5 0.3 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m98 26.6q1.2-1 2.1-2.3c0.2-0.2-0.2-0.5-0.3-0.2q-0.9 1.2-2.1 2.2c-0.2 0.1 0.1 0.4 0.3 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m99.5 27.6q1.1-1.1 1.9-2.5c0.1-0.2-0.2-0.5-0.4-0.2q-0.7 1.3-1.8 2.4c-0.2 0.2 0.1 0.5 0.3 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m98.6 22.4c1.5 0.1 2.8-1.1 2.9-2.6 0.1-1.5-1.1-2.8-2.7-2.9-1.5-0.1-2.8 1.1-2.9 2.6-0.1 1.5 1.1 2.8 2.7 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m99.8 21.1q-0.2-0.7-0.5-1.3-0.5 0.1-1 0-0.2 0.7-0.3 1.4c-0.1 0.2-0.4 0.2-0.4 0q0.3-1.8 1.1-3.4c0-0.2 0.2-0.2 0.3 0q0.5 1.6 1.1 3.2c0.1 0.2-0.2 0.3-0.3 0.1zm-0.6-1.6l-0.4-1.3q-0.3 0.7-0.5 1.3 0.5 0.1 0.9 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorProfile);
export default __webpack_public_path__ + "static/media/vectorProfile.b81495eba984707fc408bff0cc20aa9d.svg";
export { ForwardRef as ReactComponent };